







import { Vue, Component, Prop } from 'vue-property-decorator'
import store from 'src/assets/store'
import { Session, SessionAttendee } from 'src/graphql/types'

@Component
export default class SessionDuration extends Vue {

  @Prop()
  readonly session!: Session

  @Prop()
  readonly attendee!: SessionAttendee

  get serverTime () {
    return store.now()
  }
}
